import { Campaign, ProfileCountRequest } from "../models";
import { Profile } from "../models/profile.model";

export class ProfileCountRequestFactory {
  public static create(profile: Profile, campaign: Campaign): ProfileCountRequest {
    const profileCountRequest: ProfileCountRequest = {
      id: profile.id,
      priority: profile.priority,
      profileType: profile.profileType,
      definition: this.normalizeDefinition(profile.definition),
      capFixed: profile.capFixed,
      capPercentage: profile.capPercentage,
      controlPercentage: profile.controlPercentage,
      targetAudienceId: profile.targetAudienceId,
      controlAudienceId: profile.controlAudienceId
    };

    return profileCountRequest;
  }

  private static normalizeDefinition(definition: any): any {
    if (!definition) return definition;

    return {
      ...definition,
      rules: definition.rules?.map(rule => this.normalizeRule(rule))
    };
  }

  private static normalizeRule(rule: any): any {
    if (rule.rules) {
      return {
        ...rule,
        rules: rule.rules.map(r => this.normalizeRule(r))
      };
    }
    return {
      ...rule,
      value: rule.value ?? []
    };
  }
}
